<template>
  <div>
    <a-spin :spinning="spinning">
      <div class="card-rooms v-100">
        <div
          v-for="(room, index) in rooms"
          :key="index"
          class="row card-rooms-items"
        >
          <div class="col-md-5">
            <div class="card-rooms-items-left">
              <div class="position-relative">
                <img class="img-fluid" :src="room.fimg_url" alt="" />
                <!-- <div class="position-absolute end-0 bottom-0 me-2 mb-2">
                  <button class="btn btn-success">
                    <i class="bi bi-images"></i>
                  </button>
                </div> -->
              </div>
              <div class="mt-3">
                <ul class=" m-0 list-item ">
                  <li class="v-list"><i class="bi bi-water"></i> Swimming Pool</li>
                  <li class="v-list"><i class="bi bi-router"></i> Wifi</li>
                  <li class="v-list">
                    <svg
                      width="16"
                      viewBox="0 -1 511.99871 511"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="m380.589844 204.039062 30.082031-1.90625c.050781-.003906.105469-.007812.160156-.011718 21.4375-1.808594 40.679688-13.039063 52.796875-30.820313l23.78125-34.890625c20.699219-30.375 28.71875-67.0625 22.574219-103.300781-1.207031-7.117187-4.847656-13.675781-10.246094-18.460937-5.402343-4.789063-12.347656-7.617188-19.558593-7.960938-36.726563-1.757812-72.175782 10.605469-99.847657 34.796875l-31.789062 27.792969c-16.199219 14.160156-25.042969 34.609375-24.269531 56.113281.003906.050781.003906.105469.007812.160156l1.714844 30.089844c.667968 11.730469-3.632813 23.304687-11.777344 31.734375l-248.351562 255.132812c-6.648438 6.933594-10.082032 16.445313-9.664063 26.785157.460937 11.382812 5.683594 22.5625 13.972656 29.910156 7.488281 6.636719 17.78125 10.417969 28.070313 10.417969 1.101562 0 2.203125-.042969 3.300781-.132813 10.316406-.824219 19.351563-5.371093 25.46875-12.847656l223.464844-277.085937c7.410156-9.117188 18.386719-14.773438 30.109375-15.515626zm-42.039063 5.859376-223.445312 277.0625c-3.414063 4.171874-8.664063 6.742187-14.78125 7.230468-7.277344.582032-14.738281-1.839844-19.964844-6.472656-5.226563-4.636719-8.523437-11.753906-8.816406-19.046875-.25-6.128906 1.667969-11.648437 5.363281-15.5l248.332031-255.113281c11.132813-11.519532 16.992188-27.296875 16.085938-43.289063l-1.714844-30.011719c-.582031-16.832031 6.351563-32.835937 19.035156-43.925781l31.789063-27.792969c24.671875-21.566406 56.289062-32.578124 89.015625-31.023437 3.726562.179687 7.3125 1.640625 10.105469 4.117187 2.792968 2.472657 4.671874 5.863282 5.296874 9.539063 5.476563 32.308594-1.671874 65.011719-20.125 92.089844l-23.78125 34.894531c-9.488281 13.921875-24.546874 22.722656-41.328124 24.164062l-30 1.898438c-15.984376 1.015625-30.945313 8.726562-41.066407 21.179688zm0 0"
                      ></path>
                      <path
                        d="m497.820312 440.570312-166.519531-151.667968c-3.132812-2.855469-7.984375-2.628906-10.84375.503906-2.851562 3.132812-2.625 7.988281.507813 10.84375l166.476562 151.632812c3.960938 3.660157 6.207032 9.054688 6.328125 15.1875.144531 7.296876-2.71875 14.597657-7.660156 19.539063-4.9375 4.9375-12.226563 7.808594-19.539063 7.660156-6.132812-.121093-11.527343-2.367187-15.148437-6.285156l-148.382813-162.90625c-2.855468-3.136719-7.710937-3.359375-10.84375-.507813-3.132812 2.855469-3.359374 7.710938-.503906 10.84375l148.417969 162.945313c6.523437 7.054687 15.8125 11.054687 26.160156 11.257813.269531.003906.535157.007812.804688.007812 11.121093 0 22.242187-4.511719 29.886719-12.160156 7.835937-7.835938 12.378906-19.308594 12.152343-30.695313-.203125-10.347656-4.199219-19.636719-11.292969-26.199219zm0 0"
                      ></path>
                      <path
                        d="m92.609375 202.585938c12.703125 11.703124 29.207031 18.375 46.472656 18.789062.054688.003906.109375.003906.160157.003906l30.140624.09375c11.75.035156 23.042969 5.023438 30.96875 13.660156l13.277344 14.574219c1.515625 1.664063 3.589844 2.507813 5.675782 2.507813 1.84375 0 3.695312-.660156 5.164062-2 3.136719-2.855469 3.363281-7.710938.507812-10.84375l-13.296874-14.59375c-10.828126-11.804688-26.226563-18.601563-42.246094-18.65625l-30.058594-.09375c-13.355469-.339844-26.125-5.453125-36.019531-14.410156l-87.347657-103.835938c-.890624-1.0625-.824218-2.601562.15625-3.582031.671876-.675781 1.460938-.773438 1.871094-.773438s1.199219.097657 1.875.773438l79.507813 79.511719c7.859375 7.859374 20.648437 7.859374 28.507812-.003907l9.34375-9.339843v-.003907l16.589844-16.589843s.003906 0 .003906-.003907c0 0 .003907-.003906.003907-.003906l9.339843-9.339844c7.859375-7.859375 7.859375-20.648437 0-28.507812l-79.507812-79.507813c-1.03125-1.03125-1.03125-2.714844 0-3.746094.980469-.980468 2.519531-1.046874 3.582031-.15625l103.835938 87.351563c8.960937 9.890625 14.074218 22.664063 14.414062 36.015625l.089844 30.0625c.054687 16.015625 6.855468 31.414062 18.675781 42.265625l14.226563 12.957031c3.136718 2.855469 7.988281 2.628906 10.84375-.503906 2.851562-3.136719 2.625-7.988281-.507813-10.84375l-14.203125-12.9375c-8.660156-7.945312-13.644531-19.242188-13.683594-30.988281l-.09375-30.140625c0-.054688 0-.109375-.003906-.164063-.414062-17.265625-7.085938-33.769531-18.789062-46.472656-.21875-.238281-.453126-.464844-.703126-.675781l-104.222656-87.671875c-7.203125-6.0625-17.65625-5.609375-24.3125 1.046875-7.019531 7.019531-7.019531 18.4375 0 25.453125l79.507813 79.511719c1.875 1.875 1.875 4.925781 0 6.800781l-3.917969 3.914062-88.613281-88.609375c-2.996094-3-7.855469-3-10.851563 0-2.996094 2.996094-2.996094 7.855469 0 10.851563l88.613282 88.613281-5.742188 5.738281-88.613281-88.609375c-2.996094-2.996094-7.855469-2.996094-10.851563 0-3 2.996094-3 7.855469 0 10.851563l88.609375 88.613281-3.914062 3.917969c-1.875 1.875-4.925781 1.875-6.800781 0l-79.511719-79.507813c-3.398438-3.398437-7.917969-5.273437-12.726563-5.273437s-9.328125 1.875-12.726562 5.273437c-6.65625 6.65625-7.105469 17.109375-1.046875 24.316406l87.675781 104.21875c.207031.25.433594.484376.671875.703126zm0 0"
                      ></path>
                    </svg>
                      Restaurant
                  </li>
                  <li class="v-list">
                    <svg
                      width="18"
                      version="1.1"
                      id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 223.208 223.208"
                      style="enable-background: new 0 0 223.208 223.208"
                      xml:space="preserve"
                    >
                      <g>
                        <g>
                          <path
                            d="M2.082,101.895c-1.361,0.231-2.277,1.516-2.046,2.874c0.231,1.354,1.452,2.289,2.874,2.046
                            c17.074-2.911,33.384,9.085,36.353,26.664c0.1,0.499,0.386,0.877,0.697,1.218c0.396,1.133,0.755,2.277,1.224,3.398
                            c6.884,16.537,19.771,29.398,36.312,36.236c6.662,2.746,13.643,4.128,20.651,4.128c3.943,0,7.864-0.48,11.737-1.357
                            c0.441,0.438,1.06,0.706,1.72,0.706c0.661,0,1.275-0.268,1.721-0.706c3.872,0.877,7.794,1.357,11.733,1.357
                            c6.996,0,13.987-1.382,20.654-4.128c16.538-6.838,29.447-19.692,36.31-36.236c0.469-1.121,0.822-2.266,1.218-3.398
                            c0.329-0.347,0.621-0.73,0.707-1.218c2.978-17.579,19.241-29.575,36.352-26.664c1.389,0.243,2.643-0.691,2.874-2.046
                            c0.231-1.358-0.688-2.643-2.046-2.874c-13.226-2.232-25.988,3.199-34.062,13.085c0.371-9.45-1.218-18.94-4.896-27.931
                            c4.944-1.541,10.692-3.998,9.225-14.011c-0.621-4.314-4.451-7.758,0.335-20.046c0,0-8.147,1.017-13.359,8.521
                            c-2.533-7.374-8.586-8.704-7.928-16.766c0,0-13.957,7.84-6.138,21.711c-8.823-3.03-16.101,1.181-16.101,1.181
                            c11.235,6.902,10.267,11.965,12.374,15.774c5.261,9.49,11.837,7.084,16.879,5.2c0.012,0.031,0,0.064,0.012,0.088
                            c5.298,12.806,6.083,26.691,2.484,39.844c-0.128,0.414-0.194,0.828-0.311,1.242c-0.646,2.156-1.376,4.287-2.223,6.395
                            c-4.256,10.205-11.015,18.84-19.558,25.367c5.455-8.257,7.52-18.486,5.145-28.4c3.837-3.422,9.226-10.838-4.037-18.602
                            c-2.618-1.535-8.445-4.628-11.873-10.684c0,0-8.83,32.902,11.191,31.301c3.105,14.809-5.078,30.307-20.046,36.164
                            c-0.279,0.098-0.511,0.268-0.718,0.45c-5.407,1.425-10.961,1.948-16.466,1.485c12.301-5.748,21.897-15.697,27.109-28.308
                            c0.523-1.279-0.085-2.734-1.364-3.246c-1.267-0.523-2.733,0.073-3.251,1.353c-5.006,12.129-14.426,21.58-26.562,26.621
                            c-0.949,0.39-1.924,0.707-2.898,1.041v-17.993c5.103-0.572,9.877-2.862,13.519-6.759c4.141-4.433,6.381-10.297,6.351-16.502
                            l-0.067-7.429c-0.012-0.828-0.438-1.607-1.145-2.07c-0.706-0.45-1.589-0.523-2.351-0.183c-0.194,0.098-18.961,8.135-30.455,0.378
                            c-1.142-0.768-2.685-0.476-3.458,0.67c-0.773,1.145-0.475,2.703,0.661,3.471c10.525,7.112,25.148,3.55,31.761,1.352l0.036,3.873
                            c0.049,4.92-1.723,9.548-5.005,13.043c-3.233,3.464-7.539,5.395-12.121,5.431c-0.058,0-0.106,0-0.143,0
                            c-9.466,0-17.217-8.122-17.287-18.182l-0.162-19.424c-0.018-1.961,1.696-4.01,4.707-5.6c3.562-1.891,8.443-2.956,13.728-3.002
                            c8.379,0.122,14.547,3.264,14.571,6.281c0.006,0.347-0.956,1.735-4.086,3.196c-3.093,1.425-6.887,2.308-10.187,2.339
                            c-6.376-0.135-10.589-1.498-11.064-2.034c0.207-0.938,3.535-3.849,10.264-3.525c3.15,0.128,5.8,0.98,6.89,2.247
                            c0.907,1.022,2.479,1.133,3.507,0.23c1.035-0.913,1.146-2.49,0.231-3.525c-2.07-2.353-5.784-3.754-10.448-3.942
                            c-5.465-0.192-10.431,1.315-13.33,4.119c-1.41,1.353-2.131,2.862-2.119,4.372c0.061,6.973,14.417,7.027,16.1,7.039
                            c3.958-0.024,8.519-1.084,12.239-2.801c4.536-2.107,7.015-4.865,6.99-7.77c-0.079-6.488-8.562-11.399-19.619-11.226
                            c-6.096,0.049-11.783,1.321-16.03,3.586c-4.789,2.536-7.407,6.104-7.361,10.056l0.149,19.425
                            c0.125,11.855,8.729,21.488,19.702,22.84v18.03c-0.972-0.341-1.945-0.651-2.905-1.041c-12.108-5.042-21.549-14.48-26.555-26.634
                            c-0.53-1.279-1.985-1.876-3.249-1.353c-1.279,0.524-1.891,1.985-1.367,3.258c5.212,12.623,14.809,22.561,27.112,28.309
                            c-5.508,0.45-11.043-0.049-16.468-1.485c-0.207-0.184-0.436-0.354-0.715-0.463c-14.967-5.846-23.154-21.337-20.049-36.146
                            c20.015,1.583,11.186-31.308,11.186-31.308c-3.422,6.056-9.258,9.149-11.864,10.684c-13.262,7.775-7.901,15.181-4.041,18.615
                            c-2.375,9.9-0.319,20.13,5.136,28.387c-8.534-6.527-15.293-15.174-19.546-25.367c-0.88-2.113-1.607-4.262-2.232-6.43
                            c-0.106-0.396-0.188-0.805-0.301-1.188c-3.583-13.165-2.798-27.051,2.484-39.863c0.012-0.024,0-0.058,0.012-0.088
                            c5.03,1.885,11.615,4.29,16.879-5.2c2.107-3.809,1.145-8.872,12.37-15.774c0,0-7.276-4.217-16.1-1.181
                            c7.812-13.877-6.135-21.711-6.135-21.711c0.648,8.071-5.407,9.398-7.931,16.767c-5.222-7.505-13.356-8.522-13.356-8.522
                            c4.783,12.291,0.935,15.725,0.316,20.045c-1.434,10.014,4.29,12.471,9.234,14.011c-3.678,9.003-5.261,18.493-4.887,27.931
                            C28.07,105.107,15.295,99.663,2.082,101.895z"
                          ></path>
                        </g>
                      </g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                    </svg>
                   Native Flower Garden
                  </li>
                  <li class="v-list">
                    <svg
                      id="Capa_1"
                      enable-background="new 0 0 512 512"
                      viewBox="0 0 512 512"
                      width="16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g>
                        <g>
                          <path
                            d="m460.273 458.4h.066c4.166 0 7.561-3.359 7.598-7.533.03-3.481.089-10.615.153-19.352h4.099c4.197 0 7.599-3.402 7.599-7.599s-3.402-7.599-7.599-7.599h-3.997c.138-22.517.222-47.619-.053-50.926-.514-6.174-4.146-11.185-9.252-12.767-2.413-.747-8.66-1.712-14.506 5.46-5.17 6.342-30.936 52.893-36.049 62.161-1.298 2.354-1.257 5.219.111 7.534 1.366 2.315 3.855 3.736 6.543 3.736h37.905c-.048 6.814-.101 13.374-.151 19.221-.036 4.196 3.335 7.627 7.533 7.664zm-32.387-42.083c9.994-17.94 20.067-35.609 25.214-43.979.06 8.773-.003 26.085-.11 43.979z"
                          ></path>
                          <path
                            d="m373.591 403.279c-14.462 20.663-23.095 31.966-27.733 38.039-5.579 7.306-7.458 9.766-6.11 14.15.772 2.51 2.682 4.439 5.241 5.291 3.669 1.224 38.141.668 48.92.533 4.196-.053 7.555-3.498 7.502-7.694-.052-4.197-3.527-7.563-7.694-7.503-11.44.144-23.687.226-32.551.206 5.115-6.752 13.089-17.467 24.876-34.308 4.938-7.055 11.508-18.601 11.508-27.657 0-17.043-13.865-30.908-30.907-30.908-14.736 0-27.491 10.483-30.327 24.926-.808 4.118 1.874 8.112 5.992 8.921 4.118.808 8.112-1.874 8.921-5.992 1.441-7.334 7.923-12.657 15.415-12.657 8.517 0 15.472 6.812 15.704 15.274-.128.38.303 6.433-8.757 19.379z"
                          ></path>
                          <path
                            d="m452.287 248.428c-2.455-3.406-7.207-4.173-10.607-1.719l-9.621 6.938c.307-4.483.471-8.981.471-13.472 0-107.293-87.29-194.583-194.583-194.583-107.294 0-194.584 87.29-194.584 194.583s87.29 194.583 194.584 194.583c13.586 0 27.154-1.408 40.331-4.187 4.107-.866 6.734-4.897 5.868-9.003-.867-4.107-4.898-6.733-9.003-5.868-9.692 2.044-19.617 3.269-29.598 3.687v-12.526c0-4.197-3.402-7.599-7.599-7.599s-7.599 3.402-7.599 7.599v12.527c-43.74-1.832-83.479-19.396-113.695-47.174l8.801-8.802c2.967-2.968 2.967-7.779-.001-10.747-2.966-2.967-7.778-2.967-10.746 0l-8.801 8.801c-27.779-30.216-45.342-69.954-47.174-113.694h12.529c4.197 0 7.599-3.402 7.599-7.599s-3.402-7.599-7.599-7.599h-12.528c1.832-43.74 19.396-83.479 47.174-113.694l8.801 8.801c2.968 2.967 7.778 2.968 10.746 0s2.968-7.779.001-10.747l-8.801-8.802c30.216-27.779 69.955-45.342 113.695-47.174v12.527c0 4.197 3.402 7.599 7.599 7.599s7.599-3.402 7.599-7.599v-12.524c43.74 1.832 83.479 19.396 113.694 47.174l-8.802 8.802c-2.967 2.967-2.967 7.779 0 10.746 2.969 2.968 7.779 2.967 10.747 0l8.801-8.801c29.38 31.957 47.346 74.564 47.346 121.293 0 3.814-.126 7.632-.366 11.44l-7.509-8.584c-2.764-3.16-7.565-3.479-10.722-.716-3.159 2.763-3.48 7.564-.717 10.722l18.264 20.88c2.356 3.554 7.347 4.547 10.891 1.991l23.396-16.871c3.403-2.456 4.173-7.206 1.718-10.609z"
                          ></path>
                          <path
                            d="m324.404 232.576h-56.675c-2.77-10.852-11.331-19.413-22.183-22.183v-88.083c0-4.197-3.402-7.599-7.599-7.599s-7.599 3.402-7.599 7.599v88.083c-13.284 3.391-23.135 15.457-23.135 29.782 0 16.947 13.787 30.734 30.734 30.734 14.325 0 26.391-9.852 29.782-23.135h56.675c4.197 0 7.599-3.402 7.599-7.599-.001-4.197-3.402-7.599-7.599-7.599zm-86.457 23.135c-8.567 0-15.537-6.97-15.537-15.537s6.969-15.537 15.537-15.537c8.567 0 15.537 6.97 15.537 15.537-.001 8.567-6.97 15.537-15.537 15.537z"
                          ></path>
                          <path
                            d="m504.401 397.3c4.197 0 7.599-3.402 7.599-7.599v-42.331c0-24.803-19.465-45.138-43.921-46.548 5.183-19.717 7.814-40.07 7.814-60.648 0-131.503-106.422-237.946-237.946-237.946-131.506 0-237.947 106.422-237.947 237.946 0 131.505 106.423 237.946 237.947 237.946 22.245 0 44.198-3.068 65.401-9.12 2.894 22.955 22.524 40.771 46.252 40.771h115.768c25.714 0 46.633-20.92 46.633-46.633v-37.912c0-4.197-3.402-7.599-7.599-7.599s-7.599 3.402-7.599 7.599v37.912c0 17.333-14.102 31.436-31.436 31.436h-115.768c-17.333 0-31.436-14.102-31.436-31.436 0-19.98 0-99.693 0-115.768 0-17.334 14.102-31.436 31.436-31.436h108.415.072 7.281c17.333 0 31.436 14.102 31.436 31.436v42.331c0 4.197 3.401 7.599 7.598 7.599zm-201.435-49.929v105.894c-21.015 6.406-42.859 9.658-65.019 9.658-123.106 0-222.749-99.625-222.749-222.749 0-123.106 99.626-222.749 222.749-222.749 123.105 0 222.748 99.625 222.748 222.749 0 20.59-2.81 40.934-8.344 60.563h-102.752c-25.714.001-46.633 20.92-46.633 46.634z"
                          ></path>
                        </g>
                      </g>
                    </svg>
                    24 hour services
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-7">
            <div class="card-rooms-items-right">
              <h2 class="fs-6">{{ room.title.rendered }}</h2>
              <span class="__text"
                >24m² — Different views — 1 bathroom — No smokers</span
              >
              <span class="__text">{{ room.acf.camas }}</span>
              <div>
                <div class="__description" v-html="room.excerpt.rendered"></div>
                <a
                  href="javascript:void(0)"
                  class="mt-2"
                  @click="openModal(room.excerpt.rendered, room.title.rendered)"
                  >Read more</a
                >
              </div>
              <hr />
              <div class="__break">
                <h2 class="fs-6">BREAKFAST IN CUSCO</h2>
                <div class="row">
                  <div class="col-md-8">
                    <div class="__break-list">
                      <ul>
                        <li>
                          <i class="bi bi-bell"></i>
                          <span> Breakfast Included</span>
                        </li>
                        <li>
                          <i class="bi bi-bell"></i>
                          <span>
                            Free cancellation up to 12:00 PM 30 days before
                            arrival</span
                          >
                        </li>
                        <li>
                          <i class="bi bi-bell"></i>
                          <span> Guaranteed with Credit Card</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="__break-price">
                      <span
                        ><b>${{ room.acf.price }}.00</b></span
                      >
                      <div class="__break-price-btn">
                        <button @click="AddStore(room)">Book Now</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a-skeleton v-if="spinning" active />
        <a-skeleton v-if="spinning" active />
        <a-skeleton v-if="spinning" active />
      </div>
    </a-spin>
    <a-modal
      v-model:visible="visible"
      :footer="false"
      :title="modalData.title"
      @ok="visible = false"
    >
      <div v-html="modalData.text"></div>
    </a-modal>
  </div>
</template>
<script>
import { useStore } from "Vuex";
import { reactive, ref, computed, onMounted } from "Vue";
import { message } from "ant-design-vue";
const key = "updatable";
export default {
  setup() {
    const rooms = ref(null);
    const store = useStore();
    const modalData = ref({ text: "", title: "" });
    const spinning = ref(true);
    const visible = ref(false);
    onMounted(() => {
      fetch(
        "https://www.veronicaviewhotel.com/wp-json/wp/v2/posts?categories=262"
      )
        .then((res) => res.json())
        .then((data) => {
          rooms.value = data;
          console.log(rooms.value);
          spinning.value = false;
        });
    });
    const ListRooms = computed(() => store.state.ListRooms);
    const AddStore = (even) => {
      message.loading({
        content: "Loading...",
        key,
      });
      if (store.state.Details.Check_in && store.getters.NumDays > 0) {
        setTimeout(() => {
          store.dispatch("addListRooms", even);
          store.dispatch("plusCurrent", even);
        }, 2000);
      } else {
        setTimeout(() => {
          message.error({
            content: "select the check-in and check-out date!",
            key,
            duration: 2,
          });
        }, 2000);
      }
    };

    const openModal = (event, title) => {
      visible.value = true;
      modalData.value.text = event;
      modalData.value.title = title;
    };
    return {
      spinning,
      visible,
      openModal,
      modalData,
      rooms,
      AddStore,
    };
  },
};
</script>